export { default } from './NumbersSummaryStep.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersSummaryStep/index.js